import type { CompanyAccountOption } from '@chukua/common';
import { useEffect, useState } from 'react';
import { listCompanyAccountOptions } from '../company-accounts.api';

/**
 * Every account, retired ones included, for a filter rather than a form: a retired account still holds receipts, so it must stay filterable.
 * A bank account takes cheques and transfers, M-Pesa takes the paybills and tills, so two calls cover them.
 */
export function useAllCompanyAccountOptions(): CompanyAccountOption[] {
  const [options, setOptions] = useState<CompanyAccountOption[]>([]);

  useEffect(() => {
    let cancelled = false;
    Promise.all([listCompanyAccountOptions('bank_transfer', { includeRetired: true }), listCompanyAccountOptions('mpesa', { includeRetired: true })])
      .then((lists) => !cancelled && setOptions(lists.flat()))
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
}
